
<style scoped lang="less">

  .t97-wapper {
    width: 100%;
    background-color: #fff;
    .title {
      width: 1200px;
      height: 120px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .logo{
        width: 240px;
        height: 120px;
        img{
          width: 240px;
          height: 120px;
        }
      }
      .nav-model{
        width: 400px;
        height: 70px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        background-color: #f3471b;
        margin-right: 20px;
        cursor: pointer;
        .nav-item{
          color: #fff;
          flex: 1;
          text-align: center;
          font-size: 17px;
          height: 70px;
          line-height: 70px;
        }
        .colorActive{
          background-color: #fa8100;
        }
      }
    }
    .fl1{
      width: 100%;
      img{
        width: 100%;
      }
    }
   
  }
</style>
<template>
  <div class="t97-wapper">
    <div class="title" ref="title">
      <div class="logo" >
        <img src="https://img.gegejia.com/img/43d333aaa364cdc1328c66ffc5be6a4f.png" alt />
      </div>
      <div class="nav-model">
        <div class="nav-item" @click="toFloorNum(1)" :class="{'colorActive': sectionIndex == 1}">首页</div>
        <div class="nav-item" @click="toFloorNum(2)" :class="{'colorActive': sectionIndex == 2}">医疗器械</div>
        <div class="nav-item" @click="toFloorNum(3)" :class="{'colorActive': sectionIndex == 3}">联系我们</div>
      </div>
    </div>
    <div class="fl1" v-if="sectionIndex === 1">
      <img src="https://img.gegejia.com/img/9b1cf3039f1233f19a2db75f2e247c89.png" alt="">
    </div>
    <Floor2 v-if="sectionIndex === 2" :step="step" @goStep2="goStep2"></Floor2>
    <Floor3 v-if="sectionIndex === 3"></Floor3>

    <Footer></Footer>

  </div>
</template>

<script>

import Footer from "@/views/t97/block/footer";
import Floor2 from "@/views/t97/block/floor2";
import Floor3 from "@/views/t97/block/floor3";
export default {
  data() {
    return {
      sectionIndex: 1,
      step:1
    };
  },
  components: {
    Floor2,
    Floor3,
    Footer
  },
  created: function() {
    document.title = '杭州嘉岚电子商务有限公司'
    let self = this;

  },
  computed: {

  },
  created() {


  },
  mounted() {
    window.onscroll =  ()=> {
      var currentHeight = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
    
    }
  },
  methods: {
    goStep2(i) {
      this.step = 2
    },
    toFloorNum(i) {
      this.sectionIndex = i
      this.step = 1
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/views/t97/index.vue